<app-common-page-breadcrumbs [pageTitle]="title" [navigationData]="navigationData"></app-common-page-breadcrumbs>

<div *ngIf="!loaderShow"  class="filter-nav overflow-visible border-bottom bg-light py-2">
  <div class="container visible-xs-filter-bar w-100">
    <div class="d-flex justify-content-between">
      <div  class="d-flex align-items-center ">
        <div  class="md-semibold-font  text-nowrap">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
		<!-- <div class="mx-2">
			<ng-select [dropdownPosition]="'bottom'" [closeOnSelect]="true" bindValue="id" [(ngModel)]="selectedProduct"
			  notFoundText="{{'home.productHeader.NoItemsFound' | cxTranslate }}"
			  class="quote-status-selection" [(ngModel)]="selectedProduct"
			  placeholder="{{ 'home.productHeader.SelectProducts' | cxTranslate }}" bindValue="id">
			  <ng-option *ngFor="let item of proName" [value]="item">{{ item }}</ng-option>
			</ng-select>
		  </div > -->
		  <div class="ml-3">
			<ng-select [items]="commodityData" [multiple]="true" [clearable]="false" bindLabel="description" dropdownPosition="bottom"
			groupBy="id" [selectableGroup]="true" placeholder="{{ 'home.productHeader.SelectCommodity' | cxTranslate }}" [(ngModel)]="selectedCommodity"
			[closeOnSelect]="true" bindValue="id" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
			(change)="filterData()">
			<ng-template ng-multi-label-tmp>
			  <span class="filter-count pl-2 text-black">{{selectedCommodity?.length}}x {{'home.productHeader.SelectedCommodity' | cxTranslate }}</span>
			</ng-template>
			<ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">           
			  <!-- <input type="checkbox" /> -->
			</ng-template>
			<ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
			  <div>
				<input id="{{item.id}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
				<span>{{item.description}}</span>
			  </div>
			</ng-template>
		  </ng-select>
	  </div>
		  <div class="ml-3">
		  <ng-select [items]="materialList" [multiple]="true" [clearable]="false" bindLabel="name" dropdownPosition="bottom"
          groupBy="code" [selectableGroup]="true" placeholder="{{ 'home.productHeader.SelectProducts' | cxTranslate }}" [(ngModel)]="selectedProduct"
          [closeOnSelect]="true" bindValue="code" notFoundText="{{'heading.NoItemsFound' | cxTranslate }}"
          (change)="filterData()">
          <ng-template ng-multi-label-tmp>
            <span class="filter-count pl-2 text-black">{{selectedProduct?.length}}x {{'home.productHeader.SelectedProductsTypes' | cxTranslate }}</span>
          </ng-template>
          <ng-template ng-optgroup-tmp let-item="item" let-item$="item$" let-index="index" class="dropdown-ng-template">           
            <!-- <input type="checkbox" /> -->
          </ng-template>
          <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
            <div>
              <input id="{{item.code}}" [ngModel]="item$.selected" [checked]="item.checked" type="checkbox" />
              <span>{{item.name}}</span>
            </div>
          </ng-template>
        </ng-select>
	</div>
		<div class="mr-2 picker">
          <input name="datepicker" placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}"
            class="form-control mobile ml-2 mt-3 filter-bar-input" ngbDatepicker #datepicker="ngbDatepicker"
            [autoClose]="'outside'" (dateSelect)="onDateSelection($event,datepicker)"
            [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
            [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footerTemplate" autocomplete="off"
            outsideDays="visible" [startDate]="startDate!" (click)="toggle(datepicker)" >
          <ng-template #t let-date let-focused="focused">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
              [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
              (mouseleave)="hoveredDate = null">
              {{ date.day }}
            </span>
          </ng-template>
          <ng-template #footerTemplate>
            <hr class="my-0">
            <button class="btn btn-primary  btn-sm m-2 float-left" (click)="resetCalendar(datepicker)">{{
              'home.contracts.Reset' | cxTranslate }}</button>
            <button class="btn btn-secondary  btn-sm m-2 float-right" (click)="datepicker.close()">{{ 'home.quote.Close'
              | cxTranslate }}</button>
          </ng-template>
        </div>
        <div *ngIf="showClear">
          <button type="button" class="btn btn-link mb-0 ml-4" (click)="clearFilterData()"
            [style.visibility]=" startDate != null || selectedProduct!= null || selectedCommodity!= null ||clearBtn ? 'visible' : 'hidden'">{{
            'home.productHeader.ClearFilter' | cxTranslate }}</button>
        </div>
      </div>
	  <!-- Search functionality for desktop -->
      <div class="d-flex align-items-center mr-2 search-section-col">
        <div class="search-section-div">
          <div class="input-group d-flex align-items-center">
            <input class="form-control form-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttondesktop'
                class="btn btn-outline-secondary btnUpgrade rounded-pill border-0 input-field bg-white border-start-0 border-bottom-0 border ms-n5"
                type="button">
                <i class="fa fa-search pe-none"></i>
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- Search functionality for mobile -->
  <div class="container hidden-xs-filter-bar">
    <div class="row">
      <div class="w-100">
        <div class="filter-select-div-mobile pl-4">
          <div class="input-group p-2">
            <input class="form-control from-control-lg border rounded-pill input-field" type="search"
              (keypress)="omit_special_char($event)" [(ngModel)]="searchText" (input)="search()"
              placeholder="{{ 'home.productHeader.Search' | cxTranslate }}">
            <span class="input-group-append">
              <button name='searchbuttonfilter' class="
                      btn
                      rounded-pill
                      border-0
                      input-field
                      border-start-0 border-bottom-0 border
                      ms-n5
                    " type="button">
                <i class="fa fa-search mobbar"></i>
              </button>
              <div class='hidden-xs-filter-bar vertical ml-4'></div>
              <div class='hidden-xs-filter-bar pr-2 pl-4' (click)='filtersidebar()'>
                <img class="ml-1" src="./images/filternew.svg"><sup class="pl-2 pr-2 pt-1 pb-1"
                  *ngIf='length'>{{length}}</sup>
                <div class="ff-semibold fs-10 d-flex align-items-center text-black Filternew">{{ 'home.filter.filters' |
                  cxTranslate }}</div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div class="background">
      <div [ngClass]="sidebar ?'hide-mobile-filter-sidebar': 'mobile-filter-sidebar' "
        class="hidden-xs-filter-bar sidebar">
        <div class='  d-flex flex-row justify-content-between p-3 border sticky'>
          <div class="fs-24 md-semibold-font pl-1">{{ 'home.productHeader.Filter' | cxTranslate }}</div>
          <div (click)="closebar()"><img src="/images/sidebarcross.svg" alt="">
          </div>
        </div>
		<div class="scrollbar">
        <div>
          <div class="d-flex md-semibold-font  pl-3 pt-3 pb-2">{{ 'home.contracts.date' | cxTranslate }}:</div>
          <form role="form" class="date-range-picker-form ml-4">
            <div class="form-group pr-3 mb-1">
              <div class="input-group">
                <div class="input-group-prepend">

                  <input name="datepicker" class="form-control filter-mob"
                    placeholder="{{'home.contracts.selectdaterange' | cxTranslate }}" ngbDatepicker
                    #datepicker1="ngbDatepicker" [autoClose]="'outside'"
                    (dateSelect)="onDateSelection($event,datepicker1)"
                    [value]="formatter.format(startDate)?formatter.format(startDate)+' - '+formatter.format(endDate):''"
                    [displayMonths]="2" [dayTemplate]="t" [footerTemplate]="footer" autocomplete="off"
                    outsideDays="visible" [startDate]="startDate!" (click)="toggle(datepicker1)"
                    placeholder="{{ 'home.contracts.dateRange' | cxTranslate }}">
                  <ng-template #t let-date let-focused="focused">
                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                      [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                      (mouseleave)="hoveredDate = null">
                      {{ date.day }}
                    </span>
                  </ng-template>
                  <ng-template #footer>
                    <button class="btn btn-primary  btn-sm m-2 float-left" (click)="resetCalendar(datepicker1)">{{
                      'home.contracts.Reset' | cxTranslate }}</button>
                    <button class="btn btn-secondary  btn-sm m-2 float-right" (click)="datepicker1.close()">{{
                      'home.quote.Close' | cxTranslate }}</button>
                  </ng-template>
                </div>
              </div>
            </div>
          </form>
        </div>
		<div class="d-flex md-semibold-font  pl-3 pt-3 pb-2">{{ 'home.filter.products' | cxTranslate }}</div>
		<div *ngFor="let statusData of materialList; let i=index" class=" ml-5  d-flex line-height ">
            <label class="scroll-checkbox" *ngIf="statusData.name!==undefined && statusData.name!==''">
			 <input type="checkbox" [(ngModel)]="statusData.selected" [value]="statusData.code"
                [checked]="statusData.selected"  (change)="onCheckboxproductChange($event , statusData.code)"/>
            {{statusData.name }}			
            </label>
        </div>
		<div>
			<div class="d-flex md-semibold-font  pl-3 pt-3 pb-2">{{ 'home.filter.commodityType' | cxTranslate }}</div>
			<div *ngFor="let item of commodityData; let i=index" class=" ml-5  d-flex line-height ">
				<label class="scroll-checkbox" >
				<input type="checkbox"  [(ngModel)]="item.selected" [value]="item.id"
					[checked]="item.selected"  (change)="onCheckboxCommodityChange($event , item.id)"/>
				{{item.description }}
				</label>
			</div>
		</div>
	</div>
        <div class="sticky-bottom p-4 border-top">
          <button class="btn btn-block btn-primary w-100" (click)="getResults()">{{ 'home.contracts.seeResults'
            |
            cxTranslate}}</button>
          <button class='btn btn-block' (click)="clearFilterMobile($event)">{{ 'home.contracts.clearFilter' |
            cxTranslate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="!loaderShow" class="py-3">
	<div class="container desktop-inline">
		<nav class="project-tab border-bottom">
			<div class="nav nav-tab nav-fill flex-row " id="nav-tab" role="tablist">
				<div><a class="nav-item nav-link text-dark nav-align active strong" [class.active]="tenderTab === 'active'" id="nav-active-tab" data-toggle="tab" href="#nav-by-active" role="tab" aria-controls="nav-home" aria-selected="true" (click)="changeTab('active')">{{ 'home.quote.Active' | cxTranslate }}
        </a></div>
				<div><a class="nav-item nav-link text-dark nav-align d-inline-flex strong" [class.active]="tenderTab === 'expired'" id="nav-expired-tab" data-toggle="tab" href="#nav-by-expired" role="tab" aria-controls="nav-profile" aria-selected="false" (click)="changeTab('expired')">{{'tenders.Expired'| cxTranslate}}</a></div>
			</div>
		</nav>
	</div>
</div>

<div *ngIf="loaderShow" id="loader"></div>

<div infiniteScroll [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" (scrolled)="onScrollGrid()" [scrollWindow]="true">
	<!--Active Tab-->
	<div *ngIf="tenderTab=='active'">
		<div *ngIf="tenderdata?.length == 0 && !loaderShow" class="text-center strong  text-secondary my-5">{{ 'home.quote.nocurrently' | cxTranslate }}</div>
		<div *ngIf="!loaderShow" class="container py-4">

			<div *ngIf="tenderdata?.length>0 && !loaderShow">{{'tenders.secondmaterial'| cxTranslate}}</div>
			<br>
			<div *ngFor="let tenderDetailsData of tenderDetailsData,let i=index">
				<div class="card mb-5">
					<!-- Desktop View Active tab card header -->
					<div class="d-none d-lg-block">
						<div class="card-header bg-white d-flex align-items-center justify-content-between">
							<div class="small text-danger bold">{{ 'home.quote.Submissiondeadline' | cxTranslate }} {{convertDate(tenderDetailsData ?.submissionDeadline,tenderDetailsData.submissionDeadlineTimeZone)}} {{tenderDetailsData.submissionDeadlineTimeZone?tenderDetailsData.submissionDeadlineTimeZone.code:''}}<span class="text-danger pl-3 strong small small d-none d-sm-none d-md-inline-block d-lg-inline-block">{{expiryCalculate(tenderDetailsData ?.submissionDeadline)}}</span></div>
							<!--<div class="text-danger strong small">Expiring in 2h 32m</div>-->
							<div class="d-flex justify-content-between ">
							<div class="small text-secondary mr-4 bold" *ngIf="tenderDetailsData.bidsPlacedCount==0">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
							<div class="small text-danger mr-4 bold pointer" *ngIf="tenderDetailsData.bidsPlacedCount>0" [routerLink]="'/quotes/myquotes'">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
	
							<div class="small text-secondary">{{'tenders.ID'| cxTranslate}}: {{tenderDetailsData ?.quoteCode}}</div>
						</div>
						</div>
					</div>
					<!-- End Desktop View Active tab card header -->
					<!-- Mobile View Active tab card header -->
					<div class="d-lg-none">
						<div class="card-header bg-white d-flex  justify-content-between">
							<div class="small text-danger bold d-flex flex-row justify-content-between mb-2">
								<p class="mb-0">{{ 'home.quote.Submissiondeadline' | cxTranslate }}</p>
								<p class="mb-0">{{convertDate(tenderDetailsData ?.submissionDeadline,tenderDetailsData.submissionDeadlineTimeZone)}} {{tenderDetailsData.submissionDeadlineTimeZone?tenderDetailsData.submissionDeadlineTimeZone.code:''}}</p>
								<span class="text-danger pl-3 strong small small d-none d-sm-none d-md-inline-block d-lg-inline-block">{{expiryCalculate(tenderDetailsData ?.submissionDeadline)}}</span></div>
							
							<div class=" ">
								<div class="small text-secondary mb-2">{{'tenders.ID'| cxTranslate}}: {{tenderDetailsData ?.quoteCode}}</div>
								<div class="small text-secondary mr-4 mb-2" *ngIf="tenderDetailsData.bidsPlacedCount==0">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
								<div class="small text-secondary mr-4 pointer mb-2" *ngIf="tenderDetailsData.bidsPlacedCount>0" [routerLink]="'/quotes/myquotes'">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
						    </div>
						</div>
					</div>
					<!-- End Mobile View Active tab card header -->
					
					<div class="card-body">
						<div class=" d-flex row" *ngFor="let a of tenderDetailsData.combinedTenders; let j=index">
							<div [ngClass]="tenderDetailsData.combinedTenders.length==1?'mt4':''" class="col-md-9 col-sm-12 align-self-stretch">
								<div class="row col-sm-12" *ngIf="tenderDetailsData?.combinedTenders?.length>1">
									<div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{j+1}}</div>
								</div>
								<div class="row col-sm-12">
									<h4 class="strong mb-3">{{a.newName?a.newName:a.productName}}</h4></div>
								<div class="row d-flex">
									<div class="col-md-3 col-sm-12 mb-3">
										<div class="small text-secondary ">{{ 'tenders.Quantity(DMT)' | cxTranslate }} ({{a.displayQuantityUnitDesc}})</div>
										<!-- <div class="small text-secondary " *ngIf="tenderDetailsData.commodityType=='IO'">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}{{a.displayQuantityUnitDesc}}</div>
										<div class="small text-secondary " *ngIf="tenderDetailsData.commodityType=='CC'">{{ 'tenders.quantityMetricTonnes' | cxTranslate }}{{a.displayQuantityUnitDesc}}</div> -->
										<div class="strong h5 mb-0 " *ngIf=" a.minimumQuantity && a.maximumQuantity">{{a.minimumQuantity | number }} - {{a.maximumQuantity | number }}</div>
										<div class="strong h5 mb-0 " *ngIf=" a.quantity&& !a.minimumQuantity && !a.maximumQuantity ">{{a.quantity | number }}</div>
									</div>
									<div class="col-md-3 col-sm-12 mb-3">
										<div class="small text-secondary " *ngIf="tenderDetailsData.commodityType=='CN'">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
										<div class="small text-secondary " *ngIf="(tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC') && tenderDetailsData.arrivalPeriod == 'true'">{{'tenders.ArrivalPeriod'| cxTranslate}}</div>	
										<div class="small text-secondary " *ngIf="(tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC') && tenderDetailsData.arrivalPeriod == 'false'">{{'tenders.LoadPortLaycan'| cxTranslate}}</div>
										<div class="small text-secondary " *ngIf="(tenderDetailsData.commodityType=='CA') && tenderDetailsData.arrivalPeriod == 'false'">{{'tenders.schedule'| cxTranslate}}</div>		
										<div *ngIf=" tenderDetailsData.arrivalPeriod == 'false'" class=" strong ">{{a.laycanStartDate | date:"dd/MM/yyyy"}} - {{a.laycanEndDate | date:"dd/MM/yyyy"}}</div>
										<div *ngIf=" tenderDetailsData.arrivalPeriod == 'true'" class=" strong ">{{tenderDetailsData.arrivalStartDate | date:"dd/MM/yyyy"}} - {{tenderDetailsData.arrivalEndDate | date:"dd/MM/yyyy"}}</div>
									</div>
									<div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData.commodityType!='CN'">
										<div class="small text-secondary ">{{'tenders.LoadPort'| cxTranslate}}</div>
										<div class=" strong" >{{a.defaultLoadPort?a.defaultLoadPort:'--'}}</div>
									</div>
									<div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData?.incoterms!='FOB'">
										<div class="small text-secondary ">{{'tenders.DischargePort'| cxTranslate}}</div>
										<div class=" strong" >{{a.dischargePortDetails?a.dischargePortDetails:'--'}}</div>
									</div>
								</div>
							</div>
							<div class="hr mt-0 d-sm-block d-md-none" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0"></div>
							<div class="col-md-3 col-xs-12 align-self-stretch">
								<div class="row col-sm-12" *ngIf="tenderDetailsData.commodityType=='IO' || tenderDetailsData.commodityType=='CA'">
									<button  [disabled]="isPlaceBidDisabled" class="btn btn-primary btn-lg w-100 mb-3 button-placeholder" (click)="openmodal(i,'placebid')" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0">{{'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
									<div class="button-placeholder" *ngIf="!(isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0)"></div>
								</div>
								<div class="row col-sm-12" *ngIf="tenderDetailsData.commodityType=='CN'">
									<button [disabled]="isPlaceBidDisabled" class="btn btn-primary btn-lg w-100 mb-3" (click)="metalOpenmodal(i,'placebid')" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0">{{'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
									<div class="button-placeholder" *ngIf="!(isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0)"></div>
								</div>
								<div class="row col-sm-12" *ngIf="tenderDetailsData.commodityType=='CC'">
									<button [disabled]="isPlaceBidDisabled" class="btn btn-primary btn-lg w-100 mb-3" (click)="coalOpenmodal(i,'placebid')" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0">{{'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
									<div class="button-placeholder" *ngIf="!(isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0)"></div>
								</div>
								    <div class="row d-flex">
										<div class="col-md-12 col-sm-6 mb-3" *ngIf="tenderDetailsData.commodityType!='CN'">
											<div class="small text-secondary ">{{'tenders.PricingOptions'|cxTranslate}}</div>
											<div class="d-flex flex-wrap no-wrap" >
												<div *ngFor="let prices of a?.pricingOptionsEnum" class="pricing-option">
													<div class="bold text-secondary small pr-4"> <img
															[src]="(prices.pricingOptions=='FIXED_PRICE'|| prices.pricingOptions=='FIXED_PREMIUM') ? indexImage :fixedImage"
															class="pr-1" alt="icon" width="24.22" height="24.22">
														{{prices.pricingOptionsValue}}
													</div>
												</div>
											</div>
										</div>
									</div>
									
								
							</div>
                            <hr class="hr mx-3" *ngIf="tenderDetailsData.combinedTenders.length>0 && tenderDetailsData.combinedTenders.length-1 && j<tenderDetailsData.combinedTenders.length-1">
						</div>
					
					</div>
					<div class="card-footer py-3">
						<div class="d-flex row justify-content-between align-self-stretch">
							<div class="col-md-9 col-sm-12">
								<div class="row">
									<div class="col-md-3 col-sm-12 mb-3" >
										<div class="small text-secondary ">{{'tenders.ShippingTolerance'|cxTranslate}}</div>
										<div class="small">{{tenderDetailsData ?.shippingTolerance?tenderDetailsData ?.shippingTolerance:'--'}}</div>
									</div>
									<div class="col-md-3 col-sm-12 mb-3">
										<div class="small text-secondary ">{{'tenders.Incoterms'| cxTranslate}}</div>
										<div class="small">{{tenderDetailsData ?.incoterms}}</div>
									</div>
									<!-- <div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData.commodityType=='CN'">
										<div class="small text-secondary ">{{'tenders.Pricingbasis'|cxTranslate}}</div>
										<div class="small">{{tenderDetailsData.pricingBase?tenderDetailsData.pricingBase:'--'}}</div>
									</div> -->
								</div>
								<div class="row">
									<div class="col-md-3 col-sm-12 mb-3">
										<div class="small text-secondary ">{{'tenders.Seller'|cxTranslate}}</div>
										<div class="small">{{tenderDetailsData ?.sellerName?tenderDetailsData ?.sellerName:'--'}}</div>
									</div>
									<div class="col-md-3 col-sm-12 mb-3">
										<div class="small text-secondary ">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
										<div class="small">{{tenderDetailsData ?.termsAndConditions?tenderDetailsData ?.termsAndConditions.description:'--'}}</div>
									</div>
									<!-- <div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData.commodityType=='CN'">
										<div class="small text-secondary ">{{'tenders.Pricingquotation'|cxTranslate}}</div>
										<div class="small">{{tenderDetailsData.qp?tenderDetailsData.qp:'--'}}</div>
									</div> -->
								</div>
								<div class="row">
									<div class="col mb-3">
										<div class="small text-secondary ">{{'tenders.SellerRemarks'|cxTranslate}}</div>
										<div class="bold fs-18">{{tenderDetailsData ?.remark?tenderDetailsData ?.remark:'--'}}</div>
									</div>
								</div>
							</div>
							<div class="col-md-3 col-xs-12">
								<div class="row">
									<div class="d-flex flex-column col-sm-12 mb-3">
										<div class="small text-secondary "> {{'tenders.Attachment'|cxTranslate}}</div>
										<div *ngFor="let docs of tenderDetailsData ?.documents;let i=index" class="d-flex flex-row"> <img src="/images/attachment.svg" alt="icon" width="9" height="17" class="mt-1"> 
												<a class="ml-1 mb-0 strong strong shadow-none" href="{{docs.downloadURL}}" target="_blank"><span class="small ml-1 pe-auto mb-2 strong text-primary text-capitalize">{{docs?.documentName?docs?.documentName:'--'}}</span></a>				
											 </div>
									</div>
								</div>
							</div>
						</div>
						<div *ngIf="tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC'"> <a class="btn btn-link strong btn-sm pl-0" (click)="goToTenderDetail(i)">{{'tenders.ShowMoreDetails'| cxTranslate}}</a> </div>
					</div>
				</div>
			</div>
		</div>
	</div>


<!--Expired Tab-->
<div *ngIf="tenderTab=='expired'">
	<div *ngIf="tenderdata?.length == 0 && !loaderShow" class="text-center strong  text-secondary my-5">{{ 'home.quote.nocurrently' | cxTranslate }}</div>
	<div *ngIf="!loaderShow" class="container py-4">
		<div class="container" *ngFor="let tenderDetailsData of tenderDetailsData,let i=index">
			<div class="card mb-5" >
				<!-- Desktop View Expired tab card header -->
				<div class="d-none d-lg-block">
					<div class="card-header bg-white d-flex align-items-center justify-content-between">
						<div class="small text-secondary"><span class="px-3 badge badge-light mr-2">Expired</span> {{ 'home.quote.Submissiondeadline' | cxTranslate }} {{convertDate(tenderDetailsData ?.submissionDeadline,tenderDetailsData.submissionDeadlineTimeZone)}} {{tenderDetailsData.submissionDeadlineTimeZone?tenderDetailsData.submissionDeadlineTimeZone.code:''}}</div>						
						<div class="d-flex justify-content-between ">
							<div class="small text-secondary mr-4 bold" *ngIf="tenderDetailsData.bidsPlacedCount==0">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
							<div class="small text-danger mr-4 bold pointer" *ngIf="tenderDetailsData.bidsPlacedCount>0" [routerLink]="'/quotes/myquotes'">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
	
							<div class="small text-secondary">{{'tenders.ID'| cxTranslate}}: {{tenderDetailsData ?.quoteCode}}</div>
						</div>
					</div>
				</div>
				<!-- End Desktop View Expired tab card header -->
				<!-- Mobile View Expired tab card header -->
				<div class="d-lg-none">
					<div class="card-header bg-white d-flex justify-content-between">
						<div class="small text-secondary">
							<span class="p-0 badge badge-light mr-2">Expired</span>
						</div>
						<div class="small text-secondary d-flex flex-row justify-content-between mb-2">
							
							<p class="mb-0">{{ 'home.quote.Submissiondeadline' | cxTranslate }} </p>
							<p class="mb-0"> {{convertDate(tenderDetailsData ?.submissionDeadline,tenderDetailsData.submissionDeadlineTimeZone)}} {{tenderDetailsData.submissionDeadlineTimeZone?tenderDetailsData.submissionDeadlineTimeZone.code:''}}</p>
						</div>						
						<div class=" ">
							<div class="small text-secondary mb-2">{{'tenders.ID'| cxTranslate}}: {{tenderDetailsData ?.quoteCode}}</div>
							<div class="small text-secondary mr-4 mb-2" *ngIf="tenderDetailsData.bidsPlacedCount==0">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
							<div class="small text-secondary mr-4  pointer mb-2" *ngIf="tenderDetailsData.bidsPlacedCount>0" [routerLink]="'/quotes/myquotes'">{{tenderDetailsData ?.bidsPlacedCount}} {{'tenders.bidPlaced'| cxTranslate}}</div>
	
							
						</div>
					</div>
				</div>
				<!-- End Mobile View Expired tab card header -->
				<div class="card-body">
					<div class=" d-flex row" *ngFor="let a of tenderDetailsData.combinedTenders; let j=index">
						<div class="col-md-9 col-sm-12">
							<div class="row col-sm-12" *ngIf="tenderDetailsData?.combinedTenders?.length>1">
								<div class="small text-secondary">{{ 'home.headerLinks.material' | cxTranslate }} #{{j+1}}</div>
							</div>
							<div class="row col-sm-12">
								<h4 class="strong mb-3">{{a.newName?a.newName:a.productName}}</h4></div>
							<div class="row d-flex">
								<div class="col-md-3 col-sm-12 mb-3">
									<div class="small text-secondary ">{{ 'tenders.Quantity(DMT)' | cxTranslate }} ({{a.displayQuantityUnitDesc}})</div>
									<!-- <div class="small text-secondary " *ngIf="tenderDetailsData.commodityType=='IO'">{{ 'home.productHeader.Quantity(WMT)' | cxTranslate }}{{a.displayQuantityUnitDesc}}</div>
									<div class="small text-secondary " *ngIf="tenderDetailsData.commodityType=='CC'">{{ 'tenders.quantityMetricTonnes' | cxTranslate }}{{a.displayQuantityUnitDesc}}</div> -->
									<div class="strong h5 mb-0" *ngIf=" a.minimumQuantity && a.maximumQuantity">{{a.minimumQuantity | number }} - {{a.maximumQuantity | number }}</div>
									<div class="strong h5 mb-0" *ngIf=" a.quantity&& !a.minimumQuantity && !a.maximumQuantity ">{{a.quantity | number }}</div>
								</div>
								<div class="col-md-3 col-sm-12 mb-3">
									<div class="small text-secondary " *ngIf="tenderDetailsData.commodityType=='CN'">{{'tenders.Deliveryperiod'| cxTranslate}}</div>
									<div class="small text-secondary " *ngIf="(tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC') && tenderDetailsData.arrivalPeriod == 'true'">{{'tenders.ArrivalPeriod'| cxTranslate}}</div>	
									<div class="small text-secondary " *ngIf="(tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC') && tenderDetailsData.arrivalPeriod == 'false'">{{'tenders.LoadPortLaycan'| cxTranslate}}</div>	
									<div class="small text-secondary " *ngIf="(tenderDetailsData.commodityType=='CA') && tenderDetailsData.arrivalPeriod == 'false'">{{'tenders.schedule'| cxTranslate}}</div>			
									<div *ngIf=" tenderDetailsData.arrivalPeriod == 'false'" class=" strong ">{{a.laycanStartDate | date:"dd/MM/yyyy"}} - {{a.laycanEndDate | date:"dd/MM/yyyy"}}</div>
										<div *ngIf=" tenderDetailsData.arrivalPeriod == 'true'" class=" strong ">{{tenderDetailsData.arrivalStartDate | date:"dd/MM/yyyy"}} - {{tenderDetailsData.arrivalEndDate | date:"dd/MM/yyyy"}}</div>						
								</div>
								<div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData.commodityType!='CN'">
									<div class="small text-secondary ">{{'tenders.LoadPort'| cxTranslate}}</div>
									<div class=" strong" >{{a.defaultLoadPort?a.defaultLoadPort:'--'}}</div>
								</div>
								<div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData?.incoterms!='FOB'">
									<div class="small text-secondary ">{{'tenders.DischargePort'| cxTranslate}}</div>
									<div class=" strong" >{{a.dischargePortDetails?a.dischargePortDetails:'--'}}</div>
								</div>
							</div>
						</div>
						<div class="hr mt-0 d-sm-block d-md-none" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0"></div>
						<div class="col-md-3 col-xs-12">
							<!-- <div class="row col-sm-12" *ngIf="tenderDetailsData.commodityType=='IO'">
								<button class="btn btn-primary btn-lg w-100 mb-3" (click)="openmodal(i,j)" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0">{{'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
							</div>
							<div class="row col-sm-12" *ngIf="tenderDetailsData.commodityType=='CN'">
								<button class="btn btn-primary btn-lg w-100 mb-3" (click)="metalOpenmodal(i)" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0">{{'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
							</div>
							<div class="row col-sm-12" *ngIf="tenderDetailsData.commodityType=='CC'">
								<button class="btn btn-primary btn-lg w-100 mb-3" (click)="coalOpenmodal(i,j)" *ngIf="isMobile ? j === tenderDetailsData.combinedTenders?.length-1 : j === 0">{{'home.productHeader.SendBidtoQuote' | cxTranslate }}</button>
							</div> -->
							<div class="row d-flex">
								<div class="col-md-12 col-sm-6 mb-3" *ngIf="tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC'">
									<div class="small text-secondary ">{{'tenders.PricingOptions'|cxTranslate}}</div>
									<div class="d-flex" >
										<div *ngFor="let row of a?.pricingOptionsEnum" class="small text-secondary strong pr-3"> 
											<img *ngIf="row.pricingOptions=='FIXED_PRICE'" src="/images/fixed_price.svg" class="pr-1" alt="icon" width="24.22" height="24.22">
											<img *ngIf="row.pricingOptions=='INDEX_PRICE' || row.pricingOptions=='LUMP_FIXED_PRICE'" src="/images/index_price.svg" class="pr-1" alt="icon" width="24.22" height="24.22">
											{{row.pricingOptionsValue}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<hr class="hr mx-3" *ngIf="tenderDetailsData.combinedTenders.length>0 && tenderDetailsData.combinedTenders.length-1 && j<tenderDetailsData.combinedTenders.length-1">
					</div>
				</div>
				<div class="card-footer py-3">
					<div class="d-flex row justify-content-between">
						<div class="col-md-9 col-sm-12">
							<div class="row">
								<div class="col-md-3 col-sm-12 mb-3">
									<div class="small text-secondary ">{{'tenders.ShippingTolerance'|cxTranslate}}</div>
									<div class="small">{{tenderDetailsData ?.shippingTolerance?tenderDetailsData ?.shippingTolerance:'--'}}</div>
								</div>
								<div class="col-md-3 col-sm-12 mb-3">
									<div class="small text-secondary ">{{'tenders.Incoterms'| cxTranslate}}</div>
									<div class="small">{{tenderDetailsData ?.incoterms}}</div>
								</div>
								<!-- <div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData.commodityType=='CN'">
									<div class="small text-secondary ">{{'tenders.Pricingbasis'|cxTranslate}}</div>
									<div class="small">{{tenderDetailsData.pricingBase?tenderDetailsData.pricingBase:'--'}}</div>
								</div> -->
							</div>
							<div class="row">
								<div class="col-md-3 col-sm-12 mb-3">
									<div class="small text-secondary ">{{'tenders.Seller'|cxTranslate}}</div>
									<div class="small">{{tenderDetailsData ?.sellerName?tenderDetailsData ?.sellerName:'--'}}</div>
								</div>
								<div class="col-md-3 col-sm-12 mb-3">
									<div class="small text-secondary ">{{'tenders.TermsAndconditions'|cxTranslate}}</div>
									<div class="small">{{tenderDetailsData ?.termsAndConditions?tenderDetailsData ?.termsAndConditions.description:'--'}}</div>
								</div>
								<!-- <div class="col-md-3 col-sm-12 mb-3" *ngIf="tenderDetailsData.commodityType=='CN'">
									<div class="small text-secondary ">{{'tenders.Pricingquotation'|cxTranslate}}</div>
									<div class="small">{{tenderDetailsData.qp?tenderDetailsData.qp:'--'}}</div>
								</div> -->
							</div>
							<div class="row">
								<div class="col mb-3">
									<div class="small text-secondary ">{{'tenders.SellerRemarks'|cxTranslate}}</div>
									<div class="bold fs-18">{{tenderDetailsData ?.remark?tenderDetailsData ?.remark:'--'}}</div>
								</div>
							</div>
						</div>
						<div class="col-md-3 col-xs-12">
							<div class="row">
								<div class="d-flex flex-column col-sm-12 mb-3">
									<div class="small text-secondary "> {{'tenders.Attachment'|cxTranslate}}</div>
									<div *ngFor="let docs of tenderDetailsData ?.documents;let i=index" class="d-flex flex-row"> <img src="/images/attachment.svg" alt="icon" width="9" height="17" class="mt-1"> 
											<a class="ml-1 mb-0 strong strong shadow-none minimum-height" href="{{docs.downloadURL}}" target="_blank"><span class="small ml-1 pe-auto mb-2 strong text-primary text-capitalize">{{docs?.documentName?docs?.documentName:'--'}}</span></a>				
										 </div>
								</div>
							</div>
						</div>
					</div>
					<div *ngIf="tenderDetailsData.commodityType=='IO' ||tenderDetailsData.commodityType=='CC'"> <a class="btn btn-link strong btn-sm pl-0" (click)="goToTenderDetail(i)">{{'tenders.ShowMoreDetails'| cxTranslate}}</a> </div>
				</div>
			</div>
			</div>
		</div>
	</div>
</div>

